import React, { useEffect, useState } from 'react';
import { message, Tabs } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import ResetUserPasswordModal from '../../components/ResetUserPasswordModal';
import {
  CustomButton,
  CustomGoBackButton,
  ExpertNameLayout,
  FormBlock,
  GridItem,
  PagesContainerUI,
  TabsContainer,
} from '../../styles/styled';
import NewExpertPage from '../NewExpertPage';
import { ExpertChangesType, ExpertType } from '../NewExpertPage/types';
import { ExpertExpertiseComponent } from './components/ExpertExpertiseComponent/ExpertExpertiseComponent';
import { ExpertProfileComponent } from './components/ExpertProfileComponent/ExpertProfileComponent';

const { TabPane } = Tabs;

export const ExpertProfilePage = () => {
  const [currentExpert, setCurrentExpert] = useState<ExpertType | null>(null);
  const [currentExpertChangesState, setCurrentExpertChanges] = useState<ExpertChangesType>({});
  const [resetPasswordModal, setResetPasswordModal] = useState<boolean>(false);

  const navigate = useNavigate();

  const { id } = useParams();

  async function refresh() {
    if (id) {
      try {
        const response = await api.get<ExpertType>(endpoints.getExpertById(id));

        setCurrentExpert(response.data);
      } catch (err) {}
    }
  }

  useEffect(() => {
    refresh();
    //eslint-disable-next-line
  }, []);

  const changeExpertStatusTo = (statusId: number) => {
    if (id) {
      api
        .put(endpoints.putExpert(parseInt(id)), { status: { id: statusId } })
        .then(() => message.success('Данные эксперта успешно обновлены'))
        .catch(() => message.error('Произошла ошибка с обновлением данных'));
    }
  };

  return (
    <PagesContainerUI>
      <ExpertNameLayout>
        <CustomGoBackButton onClick={() => navigate(-1)}>{'<'}</CustomGoBackButton>
        {currentExpert?.last_name} {currentExpert?.first_name} {currentExpert?.patronymic}
      </ExpertNameLayout>

      <TabsContainer white>
        <button onClick={() => setResetPasswordModal(true)} className="reset-password">
          Сбросить пароль
        </button>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Профиль" key="1">
            <ExpertProfileComponent expert={currentExpert} />
            <br />
            {currentExpert && currentExpert?.status?.id === 2 && (
              <GridItem align="center" justify="center" direction="row" gap="20px">
                <CustomButton width="250px" onClick={() => changeExpertStatusTo(3)}>
                  Согласовать
                </CustomButton>
                <CustomButton lined onClick={() => changeExpertStatusTo(1)}>
                  Отказать
                </CustomButton>
              </GridItem>
            )}
          </TabPane>
          <TabPane tab="Редактировать" key="2">
            <FormBlock padding="0" white>
              <NewExpertPage
                updateChanges={(newState: ExpertChangesType) => {
                  setCurrentExpertChanges(newState);
                }}
                changesState={currentExpertChangesState}
                refresh={refresh}
                profileExpertForm={currentExpert || undefined}
                isFormComponent={true}
                id={currentExpert?.id}
              />
            </FormBlock>
          </TabPane>
          <TabPane tab="Экспертизы" key="3">
            <ExpertExpertiseComponent currentExpertId={id ? id : 1} />
          </TabPane>
        </Tabs>
      </TabsContainer>
      <ResetUserPasswordModal
        open={resetPasswordModal}
        setOpen={() => setResetPasswordModal(false)}
        id={currentExpert?.user?.id || 1}
      />
    </PagesContainerUI>
  );
};
